import React from 'react';
import { Wand2 } from 'lucide-react';
import AudioAssets from './AudioAssets';

const SoundEffectsPage: React.FC = () => {
  return (
    <AudioAssets 
      type="sound-effect" 
      title="Sound Effects"
      icon={<Wand2 size={24} />}
    />
  );
};

export default SoundEffectsPage;
